// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cust {\n  text-align: center !important;\n  padding: 10px 24px 20px !important;\n}", ""]);
// Exports
module.exports = exports;
